// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ReportListView, ReportFrequency, ReportType, PageInfo, PagedReportListView } from "../schema";

export function serialize_PagedReportListView(obj: PagedReportListView): string {
  const serialized = ((value: { items: ReportListView[]; pageInfo: PageInfo }): unknown => {
    return {
      items: ((value: ReportListView[]): unknown => {
        return value.map(
          (value: {
            active: boolean;
            corporateId: number;
            customerFullName: string;
            frequency: ReportFrequency;
            isRunning: boolean | null;
            name: string;
            prefixFileName: boolean;
            reportId: number;
            reportType: ReportType;
            targetExcel: boolean;
            timeFrameFrom: { year: number; month: number; day: number };
            timeFrameTo: { year: number; month: number; day: number };
            zipFile: boolean;
          }): unknown => {
            return {
              active: ((value: boolean): unknown => {
                return value;
              })(value["active"]),
              corporateId: ((value: number): unknown => {
                return value;
              })(value["corporateId"]),
              customerFullName: ((value: string): unknown => {
                return value;
              })(value["customerFullName"]),
              frequency: ((value: "ONE_TIME" | "DAILY" | "WEEKLY" | "MONTHLY"): unknown => {
                return value;
              })(value["frequency"]),
              isRunning: ((value: boolean | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["isRunning"]),
              name: ((value: string): unknown => {
                return value;
              })(value["name"]),
              prefixFileName: ((value: boolean): unknown => {
                return value;
              })(value["prefixFileName"]),
              reportId: ((value: number): unknown => {
                return value;
              })(value["reportId"]),
              reportType: ((value: "USERS" | "ACTIVITY" | "EXTENDED_USERS_EXPORT" | "ACTIONABLES_ACTIVITY"): unknown => {
                return value;
              })(value["reportType"]),
              targetExcel: ((value: boolean): unknown => {
                return value;
              })(value["targetExcel"]),
              timeFrameFrom: ((value: { year: number; month: number; day: number }): unknown => {
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["timeFrameFrom"]),
              timeFrameTo: ((value: { year: number; month: number; day: number }): unknown => {
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["timeFrameTo"]),
              zipFile: ((value: boolean): unknown => {
                return value;
              })(value["zipFile"]),
            };
          },
        );
      })(value["items"]),
      pageInfo: ((value: { page: number; pageSize: number; totalCount: number }): unknown => {
        return {
          page: ((value: number): unknown => {
            return value;
          })(value["page"]),
          pageSize: ((value: number): unknown => {
            return value;
          })(value["pageSize"]),
          totalCount: ((value: number): unknown => {
            return value;
          })(value["totalCount"]),
        };
      })(value["pageInfo"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_PagedReportListView(str: string): ParserResult<PagedReportListView> {
  return ((
    value: unknown,
  ): ParserResult<{
    items: ReportListView[];
    pageInfo: PageInfo;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/PagedReportListView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/PagedReportListView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "items")) {
      return { success: false, reason: `[#/components/schemas/PagedReportListView/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
    }
    const parsed_items = ((): ParserResult<ReportListView[]> => {
      return ((value: unknown): ParserResult<ReportListView[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/PagedReportListView/items]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ReportListView> => {
          return ((
            value: unknown,
          ): ParserResult<{
            active: boolean;
            corporateId: number;
            customerFullName: string;
            frequency: ReportFrequency;
            isRunning: boolean | null;
            name: string;
            prefixFileName: boolean;
            reportId: number;
            reportType: ReportType;
            targetExcel: boolean;
            timeFrameFrom: { year: number; month: number; day: number };
            timeFrameTo: { year: number; month: number; day: number };
            zipFile: boolean;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ReportListView]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ReportListView]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "active")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
            }
            const parsed_active = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/active]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["active"]);
            })();
            if (!parsed_active.success) {
              return { success: false, reason: parsed_active.reason };
            }
            if (!hasProp(value, "corporateId")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
            }
            const parsed_corporateId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ReportListView/corporateId]: '${value}' expected to be of type number.` };
              })(value["corporateId"]);
            })();
            if (!parsed_corporateId.success) {
              return { success: false, reason: parsed_corporateId.reason };
            }
            if (!hasProp(value, "customerFullName")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/customerFullName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerFullName'.` };
            }
            const parsed_customerFullName = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/customerFullName]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["customerFullName"]);
            })();
            if (!parsed_customerFullName.success) {
              return { success: false, reason: parsed_customerFullName.reason };
            }
            if (!hasProp(value, "frequency")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
            }
            const parsed_frequency = ((): ParserResult<ReportFrequency> => {
              return ((value: unknown): ParserResult<ReportFrequency> => {
                return ((value: unknown): ParserResult<"ONE_TIME" | "DAILY" | "WEEKLY" | "MONTHLY"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/ReportFrequency]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "ONE_TIME":
                      return { success: true, value: "ONE_TIME" };
                    case "DAILY":
                      return { success: true, value: "DAILY" };
                    case "WEEKLY":
                      return { success: true, value: "WEEKLY" };
                    case "MONTHLY":
                      return { success: true, value: "MONTHLY" };
                    default:
                      return { success: false, reason: `[#/components/schemas/ReportFrequency]: '${value}' expected to be enum, one of 'ONE_TIME, DAILY, WEEKLY, MONTHLY'.` };
                  }
                })(value);
              })(value["frequency"]);
            })();
            if (!parsed_frequency.success) {
              return { success: false, reason: parsed_frequency.reason };
            }
            if (!hasProp(value, "isRunning")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/isRunning]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isRunning'.` };
            }
            const parsed_isRunning = ((): ParserResult<boolean | null> => {
              return ((value: unknown): ParserResult<boolean | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/isRunning]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isRunning"]);
            })();
            if (!parsed_isRunning.success) {
              return { success: false, reason: parsed_isRunning.reason };
            }
            if (!hasProp(value, "name")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
            }
            const parsed_name = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/name]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["name"]);
            })();
            if (!parsed_name.success) {
              return { success: false, reason: parsed_name.reason };
            }
            if (!hasProp(value, "prefixFileName")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/prefixFileName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'prefixFileName'.` };
            }
            const parsed_prefixFileName = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/prefixFileName]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["prefixFileName"]);
            })();
            if (!parsed_prefixFileName.success) {
              return { success: false, reason: parsed_prefixFileName.reason };
            }
            if (!hasProp(value, "reportId")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/reportId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportId'.` };
            }
            const parsed_reportId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ReportListView/reportId]: '${value}' expected to be of type number.` };
              })(value["reportId"]);
            })();
            if (!parsed_reportId.success) {
              return { success: false, reason: parsed_reportId.reason };
            }
            if (!hasProp(value, "reportType")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/reportType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportType'.` };
            }
            const parsed_reportType = ((): ParserResult<ReportType> => {
              return ((value: unknown): ParserResult<ReportType> => {
                return ((value: unknown): ParserResult<"USERS" | "ACTIVITY" | "EXTENDED_USERS_EXPORT" | "ACTIONABLES_ACTIVITY"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/ReportType]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "USERS":
                      return { success: true, value: "USERS" };
                    case "ACTIVITY":
                      return { success: true, value: "ACTIVITY" };
                    case "EXTENDED_USERS_EXPORT":
                      return { success: true, value: "EXTENDED_USERS_EXPORT" };
                    case "ACTIONABLES_ACTIVITY":
                      return { success: true, value: "ACTIONABLES_ACTIVITY" };
                    default:
                      return { success: false, reason: `[#/components/schemas/ReportType]: '${value}' expected to be enum, one of 'USERS, ACTIVITY, EXTENDED_USERS_EXPORT, ACTIONABLES_ACTIVITY'.` };
                  }
                })(value);
              })(value["reportType"]);
            })();
            if (!parsed_reportType.success) {
              return { success: false, reason: parsed_reportType.reason };
            }
            if (!hasProp(value, "targetExcel")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/targetExcel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'targetExcel'.` };
            }
            const parsed_targetExcel = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/targetExcel]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["targetExcel"]);
            })();
            if (!parsed_targetExcel.success) {
              return { success: false, reason: parsed_targetExcel.reason };
            }
            if (!hasProp(value, "timeFrameFrom")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameFrom]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'timeFrameFrom'.` };
            }
            const parsed_timeFrameFrom = ((): ParserResult<{ year: number; month: number; day: number }> => {
              return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameFrom]: '${value}' expected to be of type string.` };
                }
                const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameFrom]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                }
                return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
              })(value["timeFrameFrom"]);
            })();
            if (!parsed_timeFrameFrom.success) {
              return { success: false, reason: parsed_timeFrameFrom.reason };
            }
            if (!hasProp(value, "timeFrameTo")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameTo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'timeFrameTo'.` };
            }
            const parsed_timeFrameTo = ((): ParserResult<{ year: number; month: number; day: number }> => {
              return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameTo]: '${value}' expected to be of type string.` };
                }
                const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ReportListView/timeFrameTo]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                }
                return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
              })(value["timeFrameTo"]);
            })();
            if (!parsed_timeFrameTo.success) {
              return { success: false, reason: parsed_timeFrameTo.reason };
            }
            if (!hasProp(value, "zipFile")) {
              return { success: false, reason: `[#/components/schemas/ReportListView/zipFile]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zipFile'.` };
            }
            const parsed_zipFile = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ReportListView/zipFile]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["zipFile"]);
            })();
            if (!parsed_zipFile.success) {
              return { success: false, reason: parsed_zipFile.reason };
            }
            return {
              success: true,
              value: {
                active: parsed_active.value,
                corporateId: parsed_corporateId.value,
                customerFullName: parsed_customerFullName.value,
                frequency: parsed_frequency.value,
                isRunning: parsed_isRunning.value,
                name: parsed_name.value,
                prefixFileName: parsed_prefixFileName.value,
                reportId: parsed_reportId.value,
                reportType: parsed_reportType.value,
                targetExcel: parsed_targetExcel.value,
                timeFrameFrom: parsed_timeFrameFrom.value,
                timeFrameTo: parsed_timeFrameTo.value,
                zipFile: parsed_zipFile.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/PagedReportListView/items]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["items"]);
    })();
    if (!parsed_items.success) {
      return { success: false, reason: parsed_items.reason };
    }
    if (!hasProp(value, "pageInfo")) {
      return { success: false, reason: `[#/components/schemas/PagedReportListView/pageInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageInfo'.` };
    }
    const parsed_pageInfo = ((): ParserResult<PageInfo> => {
      return ((value: unknown): ParserResult<PageInfo> => {
        return ((
          value: unknown,
        ): ParserResult<{
          page: number;
          pageSize: number;
          totalCount: number;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "page")) {
            return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'page'.` };
          }
          const parsed_page = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${value}' expected to be of type number.` };
            })(value["page"]);
          })();
          if (!parsed_page.success) {
            return { success: false, reason: parsed_page.reason };
          }
          if (!hasProp(value, "pageSize")) {
            return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageSize'.` };
          }
          const parsed_pageSize = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${value}' expected to be of type number.` };
            })(value["pageSize"]);
          })();
          if (!parsed_pageSize.success) {
            return { success: false, reason: parsed_pageSize.reason };
          }
          if (!hasProp(value, "totalCount")) {
            return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'totalCount'.` };
          }
          const parsed_totalCount = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${value}' expected to be of type number.` };
            })(value["totalCount"]);
          })();
          if (!parsed_totalCount.success) {
            return { success: false, reason: parsed_totalCount.reason };
          }
          return { success: true, value: { page: parsed_page.value, pageSize: parsed_pageSize.value, totalCount: parsed_totalCount.value } };
        })(value);
      })(value["pageInfo"]);
    })();
    if (!parsed_pageInfo.success) {
      return { success: false, reason: parsed_pageInfo.reason };
    }
    return { success: true, value: { items: parsed_items.value, pageInfo: parsed_pageInfo.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
